module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hG7vK"))).then(() => parcelRequire('f27HP'));